import { useState } from 'react'
import styled from 'styled-components'
import Image from "next/image";
import Link from 'next/link'
import { StyledAnchor, StyledButton } from 'src/styles/Button'
import Container from 'src/styles/Container'
import { H1, SubHeading1, Detail } from 'src/styles/Typography'
import grabColor from 'src/utils/grabColor'
import RxHeroImage from './rx-hero.jpg'

function RxHero({ verticalSlug, hero, user, setIsModalOpen = false }) {
  const [loading, setLoading] = useState(false)
  const [email, setEmail] = useState('temp')

  return (
    <HeroWrapper>
      <Container>
        <HeroInner>
          <HeroLeft>
            <Title verticalSlug={verticalSlug}>
              Save up to $95 on each prescription with our{' '}
              <span className="aff-title">
                Free Rx Discount Card<sup>*</sup>
              </span>
            </Title>
            <SubTitle>
              PolicyScout has negotiated for you discounted Rx prices across 35,000
              pharmacies nationally.
            </SubTitle>
            <div>
              <FromWrapper action="">
                <LoadingFieldset disabled={loading} aria-busy={loading}>
                  {/* <SingleLineText
                    placeholder="Enter your email address"
                    name="email"
                    label="Enter your email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  /> */}
                  {user ? (
                    <Link
                      href={{
                        pathname: '/account/rx-discounts',
                      }}
                      legacyBehavior>
                      <SearchQuotesA size="large">
                        View Free Rx Discount Card
                      </SearchQuotesA>
                    </Link>
                  ) : (
                    <>
                      {setIsModalOpen ? (
                        <SearchQuotesBtn
                          type="button"
                          size="large"
                          onClick={() => setIsModalOpen(true)}
                        >
                          Claim Free Rx Discount Card
                        </SearchQuotesBtn>
                      ) : (
                        <>
                          <Link
                            href={{
                              pathname: '/signup',
                              query: { m: 'Claim Your Free Rx Discount Card' },
                            }}
                            legacyBehavior>
                            <SearchQuotesA size="large">
                              Claim Free Rx Discount Card
                            </SearchQuotesA>
                          </Link>
                        </>
                      )}
                    </>
                  )}
                </LoadingFieldset>
              </FromWrapper>
              <ShieldCopy>
                {/* <Detail>Save as PolicyScout member - completely free.</Detail> */}
                <Detail>
                  <i>This is not insurance and completely free to use</i>
                </Detail>
              </ShieldCopy>
            </div>
          </HeroLeft>
          <HeroRight>
            <Image
              src={RxHeroImage}
              quality={100}
              alt={hero?.photo?.description || ''}
              style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
              }}
              priority
            />
          </HeroRight>
        </HeroInner>
      </Container>
    </HeroWrapper>
  );
}

export default RxHero

const ShieldCopy = styled.div`
  ${Detail} {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 1.5rem 0 1rem;
    font-size: 14px;
  }
`

const SearchQuotesBtn = styled(StyledButton)`
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 352px;
    width: 100%;
    margin: 0 auto;
  }
`

const SearchQuotesA = styled(StyledAnchor)`
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    max-width: 352px;
    width: 100%;
    margin: 0 auto;
  }
`

const HeroWrapper = styled.div`
  position: relative;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 1) 63%,
    rgba(36, 168, 80, 0.04) 63%
  );
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    background: white;
  }
`

const HeroInner = styled.div`
  display: grid;
  grid-template-columns: 408px 1fr;
  grid-gap: 0 80px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`

const HeroLeft = styled.div`
  display: flex;
  flex-direction: column;
  padding: 60px 0 20px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    padding: 2rem 0;
  }
`

const HeroRight = styled.div`
  position: relative;
  height: auto;
  width: 100%;
  height: 512px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: calc(100% + 3rem);
    margin-left: -1.5rem;
    max-height: 200px;
  }
`

const Title = styled(H1)`
  margin: 0 0 1.5rem 0;
  span {
    color: ${grabColor('brand.dark')};
  }
  span.aff-title {
    color: ${({ theme, verticalSlug }) => theme.colors[verticalSlug].DEFAULT};

    sup {
      color: ${grabColor('detail')};
      font-size: 30px;

      @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
        font-size: 24px;
      }
    }
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin: 0 0 1rem 0;
    font-size: 30px;
  }
`

const SubTitle = styled(SubHeading1)`
  margin: 0 0 2rem 0;
  max-width: 600px;
  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    margin: 0 0 1.5rem 0;
    font-size: 16px;
  }
`

const MainImageWrapper = styled.div`
  position: relative;
  margin: 0 0 0 -24px;
  max-width: 840px;
  width: 840px;
  height: 512px;
  max-height: 512px;

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    width: calc(100% + 24px + 24px);
    height: 240px;
    min-height: auto;
  }
`

const FromWrapper = styled.form`
  width: 100%;
`

const LoadingFieldset = styled.fieldset`
  display: grid;
  grid-template-columns: 1fr 135px;
  border: 0;
  padding: 0;
  margin: 0;
  width: 100%;

  &[disabled] {
    opacity: 0.5;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.desktop}) {
    grid-template-columns: 1fr;
  }
`
